<template>
    <div>
        <FlyerlineModal :name="name" class="flyerline-modal--small">
            <div v-if="user">
                <h3 class="text-shade-darker">{{'txtSaveOrder'|translate}}</h3>
                <p class="text-small mb-prj2">{{'txtSaveOrderModal'|translate}}</p>
                <label class="label-aligned text-small mb-prj d-block line-height-14" for="configName-id">{{'txtSaveOrderModalLabel'|translate}}</label>
                <input v-model="configName" id="configName-id" />
                <a @click="$emit('saveConfiguration', configName)" class="mt-2 mt-3@large btn btn--prj-min-x w-100@until-medium">
                    {{ this.buttonLabel }}
                </a>
            </div>
            <div v-else>
                <p class="h3 text-shade-darker mt-0 mb-2">{{'txtLogin'|translate}}</p>
                <SkyFormLoader form-name="prj_shop_login" @success="handleLogin"></SkyFormLoader>
            </div>
        </FlyerlineModal>
        <slot />
    </div>
</template>

<script>
    import userStatus from "mixins/userStatus";
    import FlyerlineModal from "fragments/FlyerlineModal.vue";
    import SkyFormLoader from "fragments/SkyFormLoader.vue";

    export default {
        components: {SkyFormLoader, FlyerlineModal },
        name: "SaveProductConfigurationModal",
        mixins: [ userStatus ],
        props: ['name', 'buttonLabel'],
        data() {
            return {
                configName: ""
            }
        },
        methods: {
            handleLogin(...args) {
                this.fetchUserStatus();
            }
        }
    }
</script>

<style scoped>

</style>